import { Children } from 'react';
import { isFragment } from 'react-is';

const flattenChildren = (children) => Children.toArray(children).reduce((acc, child) => {
  if (isFragment(child)) {
    return acc.concat(flattenChildren(child.props.children));
  }
  acc.push(child);
  return acc;
}, []);

export { flattenChildren };
//# sourceMappingURL=flattenChildren.es.js.map
